<template>
  <div class="exchange_point">
    <h3>전환 금액 입력</h3>
    <dl class="exchange_original">
      <dt>{{ pointInfo.pointName }}</dt>
      <dd class="form">
        <span class="original">{{ addComma(pointInfo.point) }}</span>
        <span class="unit">{{ pointInfo.pointUnitName }}</span>
      </dd>
    </dl>
    <dl class="exchange_input">
      <dt>전환포인트 입력</dt>
      <dd class="form">
        <v-input-comma
          v-model="pointComma"
          :maxlength="this.addComma(this.exchangeCurrency.exchangeMaxAmount).length"
        />
        <span class="unit">{{ pointInfo.pointUnitName }}</span>
        <v-button class="btn04" @handleClick="pointMyMax" text="최대 가능금액" />
      </dd>
      <dd class="msg red">
        <v-icon clsName="icon_error" v-if="this.pointError > 0" />
        <span v-if="pointErrorMessage">{{ pointErrorMessage }}</span>
      </dd>
    </dl>
    <dl class="exchange_result">
      <dt>전환금액</dt>
      <dd class="form">
        <span class="result">{{ addComma(pointResult) }}</span>
        <span class="unit">원 (세전)</span>
      </dd>
      <dd class="msg">
        계산된 전환 금액은 세전 금액입니다.<br />포인트 획득 방법에 따라
        <strong class="red">3.3% ~ 22% 세금 공제</strong> 후 입금됩니다.
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInputComma from '@/components/atoms/VInputComma';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';
import mixin from '@/utils/mixin';

export default {
  mixins: [mixin],
  components: {
    VInputComma,
    VButton,
    VIcon,
  },
  props: {
    point: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pointComma: '',
      pointNumber: '',
    };
  },
  computed: {
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', ['exchangeCurrency']),
    pointError() {
      if (this.pointNumber == '') {
        return 0;
      } else {
        if (this.pointNumber < this.exchangeCurrency.exchangeMinAmount) {
          return 2;
        } else if (this.pointNumber > this.exchangeCurrency.exchangeMaxAmount) {
          return 3;
        } else {
          if (this.pointNumber > this.pointInfo.point) {
            return 1;
          } else if (this.pointNumber % this.exchangeCurrency.exchangeAmountUnit != 0) {
            return 4;
          } else {
            return -1;
          }
        }
      }
    },
    pointErrorMessage() {
      switch (this.pointError) {
        case 1:
          return `보유하신 포인트보다 입력하신 포인트가 큽니다.`;
        case 2:
          return `포인트는 최소 ${this.addComma(this.exchangeCurrency.exchangeMinAmount)} 이상 신청 가능합니다.`;
        case 3:
          return `포인트는 최대 ${this.addComma(this.exchangeCurrency.exchangeMaxAmount)} 까지 신청 가능합니다.`;
        case 4:
          return `포인트는 ${this.addComma(this.exchangeCurrency.exchangeAmountUnit)} 단위로 신청 가능합니다.`;
        default:
          return '';
      }
    },
    pointResult() {
      const isBasedUSD = this.exchangeCurrency.secondExchangeRate;
      if (this.pointError > 0) return '';

      if (isBasedUSD) {
        // USD 기반 환율인 경우 1$당 원화 환율로 계산
        return (
          Math.floor(this.pointNumber / this.exchangeCurrency.exchangeRate) * this.exchangeCurrency.secondExchangeRate
        );
      }
      return Math.floor(this.pointNumber / this.exchangeCurrency.exchangeRate);
    },
  },
  watch: {
    pointComma: function (value) {
      if (value != '') {
        this.pointNumber = value.replace(/\D/g, '');
      } else {
        this.pointNumber = '';
      }
      this.exchangePoint();
    },
  },
  methods: {
    ...mapActions('point', ['getPointInfo']),
    ...mapActions('exchange', ['setExchangePoint']),
    pointMyMax() {
      this.pointComma = this.addComma(
        Math.min(
          Math.floor(this.pointInfo.point / this.exchangeCurrency.exchangeAmountUnit) *
            this.exchangeCurrency.exchangeAmountUnit,
          this.exchangeCurrency.exchangeMaxAmount,
        ),
      );
    },
    exchangePoint() {
      if (this.pointError < 0) {
        this.setExchangePoint({ point: this.pointNumber, amount: this.pointResult });
        this.$emit('btnState', false);
      } else {
        this.setExchangePoint('');
        this.$emit('btnState', true);
      }
    },
  },
  async created() {
    await this.getPointInfo();
  },
};
</script>
<style lang="scss"></style>
